import { useEffect, useRef, useState } from 'react';
import WebUniversal, { getService, WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import dayjs from 'dayjs';
import { Button, Popover, Space, Switch, Tooltip } from 'antd';
import antdMessage from '../../../utilsTsx/components/system/antdMessage';
// import fetchApi from '../../../utils/api/fetchApi';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const WebComponent = (props: any) => {
    const title = '会员交易明细';
    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;
    /** 当前打开的 Popover ID */
    const [activePopoverId, setActivePopoverId] = useState<string | null>(null);

    useEffect(() => {
    }, []);

    //表头
    const columnsHead = [
        {
            title: '类型',
            dataIndex: 'membershipTransactionType',
            render: (val: any, record: any) =>
                < Tooltip placement="topLeft" title={`商户：${record?.merchantId}；
            商户单类型：${record?.merchantOrderTypeId}；
            商户单号：${record?.merchantOrderId}；
            备注：${record?.remarks}`} > {
                        val?.name
                    }</Tooltip>
        },
        {
            title: '方案',
            dataIndex: 'membershipRechargePlans',
            render: (text: any) => text?.planName
        },
        {
            title: '店铺',
            dataIndex: 'shop',
            render: (text: any) => text?.shopName
        },
        {
            title: '交易日期',
            dataIndex: 'sysDate',
            render: (text: any) => dayjs(text.createdAt).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '余额变动',
            dataIndex: 'balanceChange',
            render: (val: number) => <text style={{ color: 'yellow' }}>{val}</text>
        },
        {
            title: '现余额',
            dataIndex: 'currentBalance'

        },
        {
            title: '赠送变动',
            dataIndex: 'giftsChange',
            render: (val: number) => <text style={{ color: 'yellow' }}>{val}</text>
        },
        {
            title: '现赠送',
            dataIndex: 'currentGifts'

        },
        {
            title: '积分变动',
            dataIndex: 'membershipPointsDetailses',
            render: (val: any) => {
                let text = '';
                for (let i = 0; i < val.length; i++) {
                    text += `${val[i].pointsChange}；`
                }
                return (<text style={{ color: 'yellow' }}>{text}</text>)
            }
        },
        {
            title: '兑换金额',
            dataIndex: 'membershipPointsDetailses',
            render: (val: any) => {
                let text = '';
                for (let i = 0; i < val.length; i++) {
                    const pointsRedeemAmount = val[i].pointsRedeemAmount;
                    if (pointsRedeemAmount !== 0) {
                        text += `${pointsRedeemAmount}；`;
                    }
                }
                return (<text style={{ color: 'red' }}>{text}</text>)
            }
        },
        {
            title: '现积分',
            dataIndex: 'membershipPointsDetailses',
            render: (val: any) => {
                let text = `${val[val.length - 1]?.currentPoints}`;
                return (<>{text !== 'undefined' ? text : ''}</>)
            }
        },
        {
            title: '成功',
            dataIndex: 'isTransactionSuccessful',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '成功日期',
            dataIndex: 'successfulDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '撤销',
            dataIndex: 'isTransactionVoid',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '撤销',
            dataIndex: 'membershipTransactionVoidType',
            render: (val: any) => val?.name
        },
        {
            title: '撤销日期',
            dataIndex: 'transactionVoidDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '',
            dataIndex: 'id',
            render: (id: string, record: any) => (
                (record.isTransactionSuccessful === true && (record.membershipTransactionTypeId === 1 || record.membershipTransactionTypeId === -1) && record.isTransactionVoid === false) ?
                    <Popover
                        title="是否撤销？"
                        trigger="click"
                        content={(<Space>
                            <Button onClick={() => setActivePopoverId(null)}>否</Button>
                            <Button type='primary' onClick={() => {
                                fetchApi.PUT(getService('business'),
                                    {
                                        body: {
                                            apiId: 'membership',
                                            apiExtend: 'transactionVoid',
                                            apiData: {
                                                membershipTransactionDetailsId: id
                                            }
                                        }
                                    }
                                ).then(res => {
                                    if (res?.success === true) {
                                        antdMessage('success', '执行撤销成功');
                                        ref.current?.fetchData?.();
                                    } else {
                                        antdMessage('error', `执行撤销错误! ${res?.message}`);
                                    }
                                });
                                setActivePopoverId(null);
                            }}>是</Button>
                        </Space>)}
                        open={activePopoverId === id}
                        onOpenChange={(visible) => {
                            setActivePopoverId(visible ? id : null);
                        }}
                    >
                        <Button type="dashed" >撤销</Button>
                    </Popover> : null)
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: title,
        apiId: 'membershipTransactionDetails',
        columns,
        serviceId: 'business',
        displayOptions: {
            showAdd: false,
            showEdit: false
        },
        expandableOptions: {
            parentKey: 'originalMembershipTransactionDetailsId',
            subColumns: columns,
            subDataName: 'children',
            isSameMainDisplayOptions: true,
            isTree: true
        },
        sendPageData: data
    };

    return (
        <>
            <AntDraggableModal
                title={title}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={1500} >
                <WebUniversal {...extendProps} ref={ref} />
            </AntDraggableModal>
        </>
    )
}

export default WebComponent;
